export const SaveDesignationListDetails = async (designationArray) => {

    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(designationArray)
        };

        const response = await fetch(`${ApiURL}designation/listupload`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: result.data, message: result.message };
        }

        return { success: true, data: result.data, message: result.message };
    } catch (error) {
        console.error("SaveDesignationDetails error:", error);
        //throw error; // Rethrow the error to be handled by the caller
    }
};


// ********Save/Update button function API */

export const SaveBinDetails = async (BinDetails) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");


        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(BinDetails),
        };

        const response = await fetch(`${ApiURL}wmsbin`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {

            if (responseData.data == "Record Already Exsist!") {
                return { success: false, data: responseData.data };

            } else if (responseData.data == "Code Already Exsist!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data };
            }

        } else if (response.status == "400") {
            return { success: false, data: responseData.data };

        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveWMSBinDetails error:", error);
    }
};

// ********End of Save/Update button function API */


// ********Delete button function API */
export const DeleteBinDetails = async (rowDelete) => {
    try {
        const ApiURL = window.Links.ApiURL
        const authToken = localStorage.getItem("authToken")

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`
            },
            body: JSON.stringify(rowDelete)
        };

        const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Cannot Delete, Record Already Used!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data }
            }
        } else if (response.status == "400") {
            return { success: false, data: responseData.data };

        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("DeleteDesignationDetails error:", error);
    }
};

// ********End of Delete button function API */



// *** Get and Set values when user search code function API*/
export const BinDetailsGetData = async (binId) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }
        };
        const response = await fetch(`${ApiURL}wmsbin/search/${binId}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success) {
                return { success: true, data: responseData.data };
            } else {
                return { success: false, data: responseData.data };
            }
        } else {
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}




export const GetBinZones= async (user , location) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }
        };
        const response = await fetch(`${ApiURL}wmsbin/getzones/${user}/${location}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success) {
                return { success: true, data: responseData.data };
            } else {
                return { success: false, data: responseData.data };
            }
        } else {
            return { success: false, data: [] };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: [] };
    }
}
// *** End of Get and Set values when user search code function API*/